var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.removeLineItem($event)}}},[_c('i',{staticClass:"fa fa-trash-o"})])}
var staticRenderFns = []

export { render, staticRenderFns }